/* istanbul ignore file */
import { useEffect, useState } from 'react';
import { useRect } from '@reach/rect';
export function useCoordinates(ref) {
    const rect = useRect(ref);
    const [coordinates, setCoordinates] = useState([0, 0]);
    useEffect(() => {
        if (rect) {
            const { top, bottom, left, right } = rect;
            const height = bottom - top;
            const width = right - left;
            const center = [
                left + width / 2,
                top + height / 2 + window.pageYOffset
            ];
            setCoordinates(center);
        }
    }, [rect, setCoordinates]);
    return coordinates;
}
//# sourceMappingURL=use-coordinates.js.map